import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  input,
  OnInit,
} from '@angular/core';
import { Checkbox } from 'primeng/checkbox';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { EditBeneficiaryAddressFormModel } from './form-group/edit-beneficiary-address-form.model';
import { FormAddress } from '../../../../shared/components/address/form-address/form-address';
import { tap } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Card } from 'primeng/card';

@Component({
  selector: 'app-form-edit-beneficiary-address',
  imports: [Checkbox, ReactiveFormsModule, FormAddress, Card],
  templateUrl: './form-edit-beneficiary-address.component.html',
  styleUrl: './form-edit-beneficiary-address.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormEditBeneficiaryAddressComponent implements OnInit {
  public formGroup =
    input.required<FormGroup<EditBeneficiaryAddressFormModel>>();
  readonly #destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.#subscribeToCzyAdresKorespondencyjnyControl();
  }

  #subscribeToCzyAdresKorespondencyjnyControl(): void {
    this.formGroup()
      ?.controls.czyAdresKorespondencyjny.valueChanges.pipe(
        tap(() => {
          this.#switchAvailabilityOfAdresKorespondencyjny();
        }),
        takeUntilDestroyed(this.#destroyRef),
      )
      .subscribe();
  }

  #switchAvailabilityOfAdresKorespondencyjny(): void {
    const adresKorespondencyjny =
      this.formGroup().controls.adresKorespondencyjny;
    const isChecked = this.formGroup().controls.czyAdresKorespondencyjny.value;

    if (isChecked) {
      adresKorespondencyjny.enable();
      adresKorespondencyjny.reset();
    } else {
      adresKorespondencyjny.disable();
    }
  }
}
